export default {
  0: "With both internal and external identity management platforms, we can offer the best products and pricing for you.",
  1: "Customer service hours: working days 9:00-19:00",
  2: "Customer service hours: 7*24 hours",
  3: "Authing SMS service includes registration, login, login exceptions, forgotten password, message changes, payment confirmation, and events confirmation, etc. Authing has a dedicated machine room, supporting large capacity and high concurrency, the maximum second transmission volume of 100,000. Authing also has the exclusive real machine monitoring, real-time monitoring and automatic switching.",
  4: "One account, two-channel operation, intelligent switching of SMS channels to ensure uninterrupted delivery of SMS.",
  5: "With the three major carriers, the triple SMS channel is reliable, and also supports virtual carrier numbers.",
  6: "Enterprise real name exclusive SMS interface, SMS sending speed up to 800 messages/sec.",
  7: "99.99% SMS CAPTCHA arrival rate",
  8: "Want to learn more about pricing for the Enterprise Edition?",
  9: "Please fill in your contact information and one of our technical experts will be in touch with you shortly to help you solve your problem.",
  10: "If you have a question, please briefly address it in the comments.",
  11: "Unified Authentication Platform, Unified Login, Single Sign-On Pricing - What is Identity Cloud?",
  用户身份管理: "User ID management",
  免费服务: "Free service：",
  免费8000次认证次数: "Free of charge 8000 times",
  统一认证云: "Unified Authentication ",
  用户管理: "User management",
  多因素认证: "Adaptive MFA",
  集成主流登录方式: "Integrated mainstream login",
  在线技术文档: "Online Technical Documents",
  免费使用: "Free access",
  增值服务: "Value-added services：",
  定制开发私有部署: "Custom Development & Private Deployment",
  更高级别安全管理: "Higher levels of security management",
  开发技术支持: "Developing technical support",
  个性化产品培训: "Personalized product training",
  咨询顾问: "Consultant",
  员工身份管理: "Employee ID management",
  免费10人团队: "Free 10-person team",
  单点登录: "SSO",
  统一认证源: "Unified Authentication Source",
  集中授权: "Centralized authorization",
  应用管理: "Application management",
  日志审计: "Log audits",
  企业咨询: "Corporate consulting",
  Authing短信服务的优势: "Advantages of Authing message service：",
  多通道备份: "Multi-channel backup",
  三网合一:
    "Combination of tri-network (including the mobile communication network,the broad&televison network and the worldwide web)",
  独立端口: "separate port",
  到达率: "Arrival rate",
  Authing短信包套餐: "Authing SMS Package",
  条: "message",
  平均每条短信01元: "Average ¥0.1 per message",
  平均每条短信005元: "Average ¥0.05 per message",
  价格咨询请联系我们: "Please contact us for pricing",
  联系销售: "Contact Sales",
  称呼: "Name",
  我们的顾问将在三日内致电你: "Our consultant will call you within three days",
  手机号: "Mobile phone number",
  公司名: "Company name",
  备注信息: "Postscript",
  提交: "Submit",
  请输入你的姓名: "Please enter your name",
  请输入你的手机号: "Please enter your mobile phone number",
  请输入合法的手机号: "Please enter a valid mobile phone number",
  请输入你的公司名: "Please enter your company name",
  提交成功: "Submitted successfully",
  activeUser: "Number of active users",
  customizable: "Customizable",
};
